import { render, staticRenderFns } from "./ProviderIconWide.vue?vue&type=template&id=62efa330&scoped=true"
import script from "./ProviderIconWide.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderIconWide.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProviderIconWide.vue?vue&type=style&index=0&id=62efa330&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62efa330",
  null
  
)

export default component.exports